<template lang="pug">
  .pho-textarea
    PhoValidationProvider(:rules="rules" :name="label")
      v-textarea.pho-textarea(
        v-model="lazyValue"
        v-on="$listeners"
        ref="textareaRef"
        spellcheck="false"
        :auto-grow="autoGrow"
        :dense="dense"
        :outlined="outlined"
        :label="label"
        :rows="rows"
        :maxlength="maxCharacterLength"
        :counter="maxCharacterLength"
        :readonly="readonly"
        :disabled="disabled"
        :hide-details="hideDetails"
        :placeholder="placeholder"
      )
</template>

<script>
import { useModelAutoBinding } from '@/helpers/misc/binding';
import PhoValidationProvider from './PhoValidationProvider.vue';

export default {
  name: 'PhoTextarea',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    rows: {
      type: String,
      default: '1',
    },
    maxCharacterLength: {
      type: Number,
      default: null,
    },
    rules: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    autoGrow: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);

    return {
      lazyValue,
    };
  },
};
</script>
